/* esm.sh - applesauce-common@5.2.0/operations/app-data */
export * from "/*applesauce-common@5.2.0/esnext/operations/app-data.mjs";
